(() => {
  'use strict';

  function parseData(node) {
    const script = node.querySelector('[data-fledglings-subscription-variants]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Fledglings subscriptions: unable to parse selling-plan data.', error);
      return null;
    }
  }

  function setSellingPlan(form, variantConfig) {
    let input = form.querySelector('input[name="selling_plan"]');

    if (!variantConfig || !variantConfig.force || !variantConfig.planId) {
      if (input && input.hasAttribute('data-fledglings-selling-plan')) input.remove();
      return;
    }

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.setAttribute('data-fledglings-selling-plan', '');
      form.appendChild(input);
    }

    input.value = variantConfig.planId;
  }

  function initialise(node) {
    if (node.dataset.fledglingsSubscriptionInitialised === 'true') return;

    const formId = node.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const variants = parseData(node);
    if (!form || !variants) return;

    node.dataset.fledglingsSubscriptionInitialised = 'true';

    const sync = () => {
      const variantInput = form.querySelector('input[name="id"]');
      const variantId = variantInput ? String(variantInput.value) : '';
      setSellingPlan(form, variants[variantId]);
    };

    form.addEventListener('change', (event) => {
      if (event.target && event.target.name === 'id') sync();
    });

    sync();
  }

  function initialiseAll(root = document) {
    root.querySelectorAll('[data-fledglings-subscription-product]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
